"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var React = __importStar(require("react"));

var PropTypes = __importStar(require("prop-types"));

var PlayerState_1 = __importDefault(require("../constants/PlayerState"));

var time_1 = require("../utils/time");

var Slider_1 = __importDefault(require("./Slider"));

var withTheme_1 = __importDefault(require("../utils/withTheme"));

var Timeline =
/** @class */
function (_super) {
  __extends(Timeline, _super);

  function Timeline() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleValueChange = function (value) {
      if (_this.props.controller && _this.props.playerState !== PlayerState_1["default"].LOADING && _this.props.playerState !== PlayerState_1["default"].STOPPED) {
        try {
          _this.props.controller.seekTo(value);
        } catch (e) {
          _this.setState(function () {
            throw e;
          });
        }
      }
    };

    _this.goToLiveButtonClick = function (event) {
      event.preventDefault();

      if (_this.props.controller) {
        var maxPosition = _this.props.controller.getMaximumPosition();

        if (maxPosition !== null) {
          _this.props.controller.seekTo(Math.floor(maxPosition));
        }
      }
    };

    return _this;
  }

  Timeline.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        position = _a.position,
        duration = _a.duration,
        uiPosition = _a.uiPosition,
        streamInfo = _a.streamInfo,
        controller = _a.controller;
    var displayPosition = uiPosition !== null && typeof uiPosition === 'number' ? uiPosition : position;
    var maxPosition = controller ? controller.getMaximumPosition() || duration : duration;
    return withTheme_1["default"](this.context.theme, {
      timeline: true,
      'timeline--live': streamInfo ? streamInfo.liveNow : false
    })(React.createElement(Slider_1["default"], {
      value: displayPosition,
      max: duration,
      onValueChange: this.handleValueChange,
      ariaLabel: "Tid",
      ariaValueText: time_1.toReadableTime(displayPosition) + " av " + time_1.toReadableTime(duration),
      dimmed: this.props.dimmed,
      badge: function badge() {
        if (!streamInfo || !streamInfo.liveNow) {
          return null;
        }

        return withTheme_1["default"](_this.context.theme, {
          timeline__badge: true,
          'timeline__badge--live': true
        })(React.createElement("button", {
          "aria-label": "G\xE5 till direkt",
          onClick: _this.goToLiveButtonClick,
          tabIndex: 0,
          style: {
            left: Math.min(maxPosition / duration * 100, 100) + "%"
          }
        }, "Direkt"));
      },
      hoverBadge: function hoverBadge(hoverPercentage, value) {
        return withTheme_1["default"](_this.context.theme, {
          timeline__badge: true,
          'timeline__badge--time': true
        })(React.createElement("span", {
          style: {
            left: hoverPercentage + "%"
          }
        }, time_1.toReadableTime(value)));
      }
    }));
  };

  Timeline.contextTypes = {
    theme: PropTypes.object
  };
  return Timeline;
}(React.Component);

exports["default"] = Timeline;